<template>
  <div class="my-machines-order-history">
    <div class="my-machines-order-history__actions">
      <oie-base-input v-model="searchPhrase" :placeholder="t('filterMyMachinesOrderHistory')" class="my-machines-order-history__search">
        <template #iconPrepend>
          <oie-base-icon icon="filter-icon" size="s"></oie-base-icon>
        </template>
      </oie-base-input>

      <div class="my-machines-order-history__dates">
        <datepicker
          ref="fromDate"
          v-model="fromDate"
          :placeholder="t('fromDateLabel')"
          :monday-first="true"
          wrapper-class="datepicker"
          calendar-class="datepicker-calendar"
          input-class="datepicker-input"
          format="yyyy-MM-dd"
          :language="language"
          :full-month-name="true"></datepicker>
        <datepicker
          ref="toDate"
          v-model="toDate"
          :placeholder="t('toDateLabel')"
          :monday-first="true"
          wrapper-class="datepicker"
          calendar-class="datepicker-calendar"
          input-class="datepicker-input"
          format="yyyy-MM-dd"
          :language="language"
          :full-month-name="true"></datepicker>
      </div>
    </div>
    <div v-element-loader="{ endpoint: 'my-machines/orders' }" class="my-machines-order-history__list">
      <ul v-if="orders">
        <li v-for="order in orders" :key="order.orderNumber">
          <oie-order-history-item :order="order"></oie-order-history-item>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { en } from 'vuejs-datepicker/dist/locale'
import httpService from '../core/http-service'
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
import _ from 'lodash'

export default {
  components: {
    Datepicker
  },
  props: {
    id: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      orders: null,
      fromDate: null,
      toDate: null,
      searchPhrase: '',
      language: en
    }
  },
  computed: {
    queryParams() {
      return `${this.fromDate}|${this.fromDate}|${this.searchPhrase}`
    }
  },
  watch: {
    queryParams: _.debounce(function() {
      this.getOrderHistory()
    }, 400)
  },
  async mounted() {
    this.toDate = new Date()
    this.fromDate = new Date()
    this.fromDate.setFullYear(this.fromDate.getFullYear() - 1)
    this.getOrderHistory()
  },
  methods: {
    async getOrderHistory() {
      const response = await httpService.get('my-machines/orders', { ...this.id, fromDate: this.fromDate, toDate: this.toDate, searchPhrase: this.searchPhrase })
      this.orders = response.data
    }
  }
}
</script>

<style lang="scss">
.my-machines-order-history__actions {
  display: flex;
  gap: measure(eighth);
  flex-wrap: wrap;
  margin-bottom: measure(half);
}

.my-machines-order-history__search {
  margin-right: auto;

  @include media(medium) {
    max-width: 20rem;
  }
}

.my-machines-order-history__dates {
  display: flex;
  flex-direction: column;
  gap: measure(eighth);
  width: 100%;

  @include media(medium) {
    flex-direction: row;
    width: auto;
  }
}

.my-machines-order-history__list > ul{
  @include reset-list;
}

.my-machines-order-history__list > ul > li:not(:last-child){
  margin-bottom: measure(half);
}
</style>
